export default {
  create: {
    title: 'Adicionar',
    subtitle: 'Jogos',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Jogo',
    button: {
      add: 'Novo jogo',
    },
  },
  list: {
    title: 'Number Square',
    subtitle: 'Lista',
    add: 'Novo jogo',
  },
  card: {
    title: 'Number Square',
    actions: 'Ações',
  },
  table: {
    title: 'Jogos Ativos',
    searchPlaceholder: 'Procurar por algo...',
  },
  form: {
    name: {
      label: 'Nome:',
      placeholder: 'Ex: Number Square Nível 1',
      invalid: 'Nome é obrigatório',
    },
    showAnswer: {
      label: 'Mostrar resposta',
    },
    colored: {
      label: 'Colorido',
    },
    maxValue: {
      label: 'Números disponíveis:',
      option9: '1 até 9',
      option16: '1 até 16',
      option25: '1 até 25',
    },
    difficulty: {
      label: 'Dificuldade:',
      easy: 'Fácil',
      medium: 'Médio',
      hard: 'Difícil',
      random: 'Aleatório',
    },
    distribution: {
      checkboxLabel: 'Distribuir por porcentagem',
      tooltipText:
        'Os operadores matemáticos serão distribuídos no jogo conforme as porcentagens definidas abaixo.',
    },
    operators: {
      plus: 'Soma (+)',
      minus: 'Subtração (-)',
      times: 'Multiplicação (×)',
      divide: 'Divisão (÷)',
    },
  },
  button: {
    generate: 'Gerar Jogo',
  },
  sidebar: {
    exportHint: 'Você precisa salvar antes de exportar.',
    defaultFileName: 'numberSquare',
  },
  alert: {
    generated: 'Puzzle gerado com sucesso!',
    generateFailed: 'Não foi possível gerar o puzzle.',
    workerError: 'Erro interno na geração.',
    gameSaved: 'Jogo salvo com sucesso!',
    workerErrors: {
      noCombinations:
        'Não foi possível gerar combinações com estes operadores. Tente novamente.',
    },
  },
};
